"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _default = {
  container: {
    width: '100vw',
    minHeight: '100vh',
    display: 'flex',
    flexDirection: 'column',
    justifyContent: 'flex-start',
    alignItems: 'center',
    backgroundColor: '#f5f5f5'
  },
  logoBar: {
    width: '100%',
    display: 'flex',
    justifyContent: 'flex-end',
    marginRight: '5vw'
  },
  infoContainer: {
    maxWidth: '1200px',
    fontWeight: '300',
    fontSize: '1.2rem',
    textAlign: 'left'
  },
  headerLogo: {
    height: '200px',
    width: 'auto'
  }
};
exports.default = _default;

//# sourceMappingURL=TermsConditions.css.js.map